import { Component ,Input } from '@angular/core';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { CreatorPage } from './creator.page';
import { ActivatedRoute, Router, UrlSerializer } from "@angular/router";


// const URL = 'http://192.168.1.110:8083/api/upload';
const URL = 'http://192.168.1.110:8083/api/upload';
@Component({
  selector: 'Multerfileupload, [Multerfileupload]',
  templateUrl: './Multerfileupload.component.html',
  styleUrls: ['../app.component.css']

})
export class Multerfileupload {
  public uploader: FileUploader = new FileUploader({
    url: sessionStorage.getItem("uploadurl"),
    itemAlias: 'image'
  });
  editdata;
  upldfiles;
  assignmentid;
  hasBaseDropZoneOver:boolean;
  hasAnotherDropZoneOver:boolean;
  response:string;
  @Input() itemarrdata;
  message ;
 removebutton = 0;
 uplodedfiles;
 constructor (private router: Router,private route: ActivatedRoute){
  var itemarr=[]
  this.uploader.onAfterAddingFile = (file) => {
    file.withCredentials = false;
  };
  this.uploader.onCompleteItem = (item: any, status: any) => {
    // console.log('Uploaded File Details:', item);
    if(status != "" && status != null) 
    {
    if(!itemarr.includes(JSON.parse(status)['file']))
      itemarr.push(JSON.parse(status)['file']);
    }
    this.removebutton = 1;
  };
   this.message=itemarr;   
}
 ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.assignmentid = (params["Aid"]);
    });
    if (this.assignmentid == undefined) {
      this.upldfiles = null;
    }
    else {
      this.editdata = JSON.parse(sessionStorage.getItem("editdata"));
      this.upldfiles = this.editdata.resourcesinfo;
       var fileItems = [];

  //  fileItems[0] = new this.uploader.FileItem(this.uploader, {
  //      dateModified: 'today',
  //      size: 452,
  //      type: 'image/png',
  //      name: 'rrr'
  //  })

  //  fileItems[0].progress = 100;
  //  fileItems[0].isUploaded = true;
  //  fileItems[0].isReady = true;
  //  fileItems[0].isSuccess = true;

  //  this.uploader.queue.push(fileItems[0]);
  //  this.uploader.onAfterAddingFile(fileItems[0]);
    }
  }
  
  public fileOverBase(e:any):void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e:any):void {
    this.hasAnotherDropZoneOver = e;
  }
  deleteitem(item)
 {
  item.remove();
  console.log(item.file.name);
 }
}
